import React, { useState } from 'react'
import TotalUsers from './User/TotalUser'
import Subscribers from './Subscribers/Subscribers'

const DashbordPage = () => {

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('users');

  return (
    <>
      <div className="admin-dashboard-container">
        {loading && <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>}
        
        <div className="admin-tabs-container">
          <div className="admin-tabs-header">
            <button 
              className={`admin-tab-item ${activeTab === 'users' ? 'active' : ''}`}
              onClick={() => setActiveTab('users')}
            >
              Users
            </button>
            <button 
              className={`admin-tab-item ${activeTab === 'subscribers' ? 'active' : ''}`}
              onClick={() => setActiveTab('subscribers')}
            >
              Subscribers
            </button>
          </div>
          
          <div className="admin-tabs-content">
            {activeTab === 'users' && <TotalUsers />}
            {activeTab === 'subscribers' && <Subscribers />}
          </div>
        </div>

      </div>
    </>
  )
}

export default DashbordPage